exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2SHsZ8CtT6BtUM{padding:0 0 0 8px;margin:0;background:none;font-size:16px;line-height:32px;font-weight:500;min-width:76px;text-align:center}._2SHsZ8CtT6BtUM:active,._2SHsZ8CtT6BtUM:hover{background:none;color:inherit}._2Devn8oIOknBo0{margin-right:4px}", ""]);

// exports
exports.locals = {
	"dateButton": "_2SHsZ8CtT6BtUM",
	"dateText": "_2Devn8oIOknBo0"
};